import React from 'react';

import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here

import StageMediaImage from "../../views/stage/StageMediaImage.jsx"
import StageMediaMovie from "../../views/stage/StageMediaMovie.jsx"
import ImageHolder from "../../views/stage/MoviePlayer/ImageHolder.jsx"
import MoviePlayerHolder from "../../views/stage/MoviePlayer/MoviePlayerHolder.jsx"

const IMAGE_QUALITY_ORIGINAL = 0;
const IMAGE_QUALITY_FAST = 1;

class StageMediaView extends React.Component {
  IMAGE_QUALITY_ORIGINAL() {
    return IMAGE_QUALITY_ORIGINAL;
  }

  IMAGE_QUALITY_FAST() {
    return IMAGE_QUALITY_FAST;
  }

  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      playbackTime: 0,
      playbackDuration: 0,
      imageQuality: IMAGE_QUALITY_ORIGINAL,
      changeFileConfirmed: false,
    };
    autoBind(this);

    this.state.playbackDuration = parseInt(this.props.parent.state.stageData.duration);
  }

  updatePlaybackTime(value) {
    this.setState({ playbackTime: value });
    this.state.playbackTime = value;

    // console.log("update playback time: " + String(value));

    if (this.props.parent.onPlaybackTimeUpdate) {
      this.props.parent.onPlaybackTimeUpdate();
    }
  }

  refreshPlaybackTime(){
    var playbackTime = this.state.playbackTime;
    this.updatePlaybackTime(0);
    this.updatePlaybackTime(playbackTime);
  }

  seekVideoPlayback() {
    if (this.refs.stageMediaMovie) {
      if (this.refs.stageMediaMovie.refs.reactPlayer) {
        this.refs.stageMediaMovie.refs.reactPlayer.seekTo(this.state.playbackTime);
      }
    }
  }

  render() {
    let stageData = this.props.parent.state.stageData;
    let movieData = {};
    if (stageData['movie_list'].length > 0) {
      movieData = stageData['movie_list'][0];
    }
    let file_id = movieData['file_id'];

    if (this.state.changeFileConfirmed) {
      stageData['movie_list'] = [];
    }

    return (
      <div>
        <Switch condition={stageData['kind']}>
          <Case value="0">
            <StageMediaMovie parent={this} root={this.props.root} ref="stageMediaMovie"
              stageData={stageData} file_id={file_id} maxHeight={this.props.maxHeight}
            />
            <MoviePlayerHolder parent={this} root={this.props.root} ref="moviePlayerHolder"/>
          </Case>
          <Case value="1">
            <StageMediaImage parent={this} root={this.props.root} ref="stageMediaImage"
              stageData={stageData} file_id={file_id} maxHeight={this.props.maxHeight}
              showAIGeneration={this.props.showAIGeneration}
              aiGenerateEnabled={this.props.aiGenerateEnabled}
              aiGenerateQuotaTotal={this.props.aiGenerateQuotaTotal}
              localeData={this.props.localeData}
              onUploadSuccess={this.props.onUploadSuccess}
            />
            <ImageHolder parent={this} root={this.props.root} ref="imageHolder"/>
          </Case>
        </Switch>

      </div>
    )
  }
}

export default StageMediaView;
